/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// custom component import
import createIcon from '../../../../assets/images/feather-settings.svg';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
// custom function import
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { manuFactureHead, labelerHead } from './gridComponents/tableHead';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getAllManufacturer,
  getAllMFGLabelerList,
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getSingleLabelerUsingMFG,
  maintainLabelerListData,
  addNewRowBankruptcy,
  getSingleContractUsingContact,
  getExistingContactDetails,
  getContactDetails,
  getGetAllProviderList,
  setSearchManufacturerTab,
  setMaintainManufacturerTab,
  dispatchLabelerUsingManufacturer,
} from '../store/ManufacturerAction';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

// double click on row after calling
export const getManufacturerDetails = (data, history, dispatch, props) => {
  if (data.mfgTypeCd === undefined) {
    data.mfgTypeCd = props.mfgTypeCd;
  }
  dispatch(setSelectManufacturerData(data));
  redirectURLLink(
    '/manufacturer-detail',
    'Maintain Manufacturer',
    history,
    dispatch
  );
};

const ManufacturerSearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const setSearchManufacturer = (value) =>
    dispatch(setSearchManufacturerTab(value));

  const searchManufacturerData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.searchManufacturerObj
  );
  const updateManufacturerTabData = useSelector((state) => {
    return state.sharedState.ManufacturerReducer.maintainManufacturerObj;
  });
  const manufacturerFilterByGovList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.manufacturerFilterByGovList
  );
  const manufacturerFilterByComList = useSelector(
    (state) => state.sharedState.ManufacturerReducer.manufacturerFilterByComList
  );
  const MFGLabelerData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.MFGLabelerList
  );
  const labelerCommercialFlag = useSelector(
    (state) => state.sharedState.ManufacturerReducer.labelerCommercialFlag
  );
  const singleManufacturerData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.labelerUsingMFG
  );
  const FetchAllProviderListData = useSelector(
    (state) => state.sharedState.ManufacturerReducer.allProviderListData
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const gridRef = React.useRef();
  const [spinnerLoader, setSpinnerLoader] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [columnDefs, setColumnDefs] = React.useState(manuFactureHead);
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
  );
  const [state, setState] = React.useState({
    mfgTypeCd: 'G',
    mfgSearchBy: 'Manufacturer',
  });


  // check role based access for State and Inquiry State employees
  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_REPORT_ROLE, kcRoles)
      );
    }
  }, []);
  // select mgf search by labeler and mfg type Commercial
  // React.useEffect(() => {
  //   if (state.mfgTypeCd === 'C' && state.mfgSearchBy === 'Labeler' && Object.keys(singleManufacturerData).length > 0 ) {
  //     const obj = {};
  //     obj.mfgId = singleManufacturerData;
  //     obj.mfgName = '';
  //     obj.mfgTypeCd = 'C';
  //     obj.updateManufacturer = true;
  //     obj.callAllProviderAPI = true;
  //     if (obj.mfgId && Object.keys(obj.mfgId).length > 0) {
  //       getManufacturerDetails(obj, history, dispatch, state);
  //     }
  //     dispatch(fetchAllManufacturerDetail(null));
  //   }
  // }, [
  //   singleManufacturerData
  // ]);

  React.useEffect(()=>{
    setSpinnerLoader(false)
  },[MFGLabelerData])
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // Service call for  all Governmental Manufacturer
  const fetchDataFromServer = (data, mfgTypeCd, action) => {
    dispatch(getAllManufacturer(data, mfgTypeCd, action));
  };
  // Service call for all Commercial Labelers
  const fetchAllMFGLabelers = (data, action) => {
    dispatch(getAllMFGLabelerList(data, action));
  };
  // Apply tab refresh
  React.useEffect(() => {
    if (
      searchManufacturerData &&
      Object.keys(searchManufacturerData).length === 0
    ) {
      setSpinnerLoader(false);
      if (
        updateManufacturerTabData &&
        Object.keys(updateManufacturerTabData).length === 0
      ) {
        dispatch(maintainLabelerListData({}));
        dispatch(addNewRowBankruptcy({}));
        dispatch(getSingleLabelerUsingMFG(null));
        dispatch(getSingleContractUsingContact(null));
        dispatch(getExistingContactDetails(null));
        dispatch(getContactDetails(null));
      }
      setSpinnerLoader(true);
      fetchAllMFGLabelers({
        mfgId: null,
        showAllInd: true,
        filterBy: 'commercial',
      });
      fetchDataFromServer({
        showAllInd: null,
        mfgId: null,
        filterBy: 'manufacturer',
        mfgTypeCd: 'G',
      });
      fetchDataFromServer({
        showAllInd: null,
        mfgId: null,
        filterBy: 'manufacturer',
        mfgTypeCd: 'C',
      });
      setSearchManufacturer({
        state: state,
      });
    } else {
      const tempObj = searchManufacturerData;
      setState(tempObj.state);
      if (tempObj.state.mfgSearchBy === 'Labeler') {
        setColumnDefs(labelerHead);
        setSpinnerLoader(true);
        fetchAllMFGLabelers({
          mfgId: null,
          showAllInd: true,
          filterBy: 'commercial',
        });
      } else {
        if (tempObj.state.mfgTypeCd === 'G') {
          fetchDataFromServer({
            showAllInd: null,
            mfgId: null,
            filterBy: 'manufacturer',
            mfgTypeCd: 'G',
          });
        } else {
          fetchDataFromServer({
            showAllInd: null,
            mfgId: null,
            filterBy: 'manufacturer',
            mfgTypeCd: 'C',
          });
        }
        setColumnDefs(manuFactureHead);
      }
      setFullScreenView(tempObj.fullScreenView);
    }
    // if (!FetchAllProviderListData?.length > 0)
    //   dispatch(getGetAllProviderList(''));
  }, [searchManufacturerData]);
  React.useEffect(() => {
    if (
      (manufacturerFilterByGovList && manufacturerFilterByGovList.length > 0) ||
      (manufacturerFilterByComList && manufacturerFilterByComList.length > 0)
    ) {
      setSpinnerLoader(false);
    }
  }, [manufacturerFilterByGovList]);
  // set full screen click icon button
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setSearchManufacturer({
      ...searchManufacturerData,
      fullScreenView: !fullScreenView,
    });
  };
  // Clear filter
  const handleClearFilter = () => {
    gridRef.current.clearFilters();
  };
  // on change value after call
  const handleChange = (e) => {
    const newObj = { ...state };
    if (e.target.name === 'mfgTypeCd' && e.target.value === 'G') {
      newObj.mfgSearchBy = 'Manufacturer';
      setColumnDefs(manuFactureHead);
    } else if (newObj.mfgTypeCd === 'C' && e.target.value === 'Labeler') {
      setColumnDefs(labelerHead);
    } else {
      setColumnDefs(manuFactureHead);
    }
    newObj[e.target.name] = e.target.value;
    setState(newObj);
    dispatch(getSingleLabelerUsingMFG(null));
    handleClearFilter();
    setSearchManufacturer({
      ...searchManufacturerData,
      state: newObj,
      fullScreenView: fullScreenView,
    });
  };

  return (
    <div className="tabs-container" data-testid="manufacturerSearch">
      <div className="tBillPanel custom-check" data-testid="mfg-search">
        <div className="paneldevider-line">
          {!fullScreenView && (
            <>
              <Spinner load={spinnerLoader} />
              <CustomSeparator parent1="Maintain" parent2="Manufacturer" />
            </>
          )}
          {!fullScreenView && (
            <div className="panel mb-3">
              <div className="row">
                <div className="col-xs-12 col-sm-6 col-md-5">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">
                      Manufacturer Type
                    </legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              data-testid="mfgType"
                              row
                              name="mfgTypeCd"
                              value={state.mfgTypeCd}
                              onChange={handleChange}
                            >
                              <FormControlLabel
                                value="C"
                                control={<Radio />}
                                label="Commercial"
                                id="commercial"
                              />
                              <FormControlLabel
                                value="G"
                                control={<Radio />}
                                label="Governmental"
                                id="governmental"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-4 mt-2 mt-sm-0">
                  <fieldset className="custom-fieldset">
                    <legend className="same-font-family">Search By</legend>
                    <div className="form-wrapper p-0">
                      <div className="mui-custom-form with-select field-xl no-lbl">
                        <TextField
                          id="search_by_type"
                          data-testid="search_by_type"
                          fullWidth
                          label="search by type"
                          className="frr-display-hidden-label"
                          select
                          placeholder=""
                          required
                          disabled={state.mfgTypeCd === 'G'}
                          inputProps={{ maxLength: 11, id: 'search_by_type' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="mfgSearchBy"
                          value={state.mfgSearchBy}
                          onChange={handleChange}
                        >
                          <MenuItem key="Manufacturer" value="Manufacturer">
                            Manufacturer
                          </MenuItem>
                          <MenuItem key="Labeler" value="Labeler">
                            Labeler
                          </MenuItem>
                        </TextField>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-sm-6 col-md-3">
                  <Button
                    className="btn-success same-font-family frr-btn-width-17 mt-4"
                    data-testid="addCreateManufacturer"
                    type="button"
                    onClick={() => {
                      dispatch(maintainLabelerListData({}));
                      dispatch(addNewRowBankruptcy({}));
                      dispatch(setMaintainManufacturerTab({}));
                      dispatch(getSingleLabelerUsingMFG(null));
                      dispatch(getSingleContractUsingContact(null));
                      dispatch(getExistingContactDetails(null));
                      dispatch(getContactDetails(null));
                      const obj = { ...state };
                      obj.createManufacturer = true;
                      obj.callAllProviderAPI = true;
                      getManufacturerDetails(obj, history, dispatch, state);
                    }}
                    disabled={!isEnablebyRole}
                  >
                    <img className="manufactureImg" alt="" src={createIcon} />
                    Create Manufacturer
                  </Button>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          )}
        </div>
        {state.mfgTypeCd !== 'G' && (
          <TableGrid
            ref={gridRef}
            gridHeight={fullScreenView ? '70vh' : 400}
            rowData={
              // eslint-disable-next-line no-nested-ternary
              state.mfgTypeCd === 'C' && state.mfgSearchBy === 'Labeler'
                ? MFGLabelerData
                : state.mfgTypeCd === 'C'
                ? manufacturerFilterByComList
                : manufacturerFilterByGovList
            }
            columnDefs={columnDefs}
            cellClickedListener={(e) => {
              dispatch(setSelectManufacturerData({}));
              dispatch(fetchAllManufacturerDetail(null));
              dispatch(getContactDetails(null));
              dispatch(maintainLabelerListData({}));
              dispatch(setMaintainManufacturerTab({}));
              dispatch(getSingleContractUsingContact(null));
              if (state.mfgTypeCd === 'C' && state.mfgSearchBy === 'Labeler') {
                // dispatch(
                //   getSingleLabelerUsingMFG({ labelerCode: e.data.labelerCode })
                // );
                dispatch(dispatchLabelerUsingManufacturer(e.data.mfgId))
                const obj = {};
                obj.mfgId = e.data.mfgId;
                obj.mfgName = '';
                obj.mfgTypeCd = 'C';
                obj.updateManufacturer = true;
                obj.callAllProviderAPI = true;
                if (obj.mfgId && Object.keys(obj.mfgId).length > 0) {
                  getManufacturerDetails(obj, history, dispatch, state);
                }
                dispatch(fetchAllManufacturerDetail(null));
              } else {
                const Obj = e?.data;
                Obj.createManufacturer = false;
                Obj.callAllProviderAPI = true;
                getManufacturerDetails(Obj, history, dispatch, state);
              }
            }}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            helpMessage="* On Double Click of Results, system should navigate to Detail page"
            data-testid="onEditingStopped"
            fileName="Manufacturer"
            frameworkComponents={{
              RenderMFGName: (cellInfo) => {
                const name = cellInfo?.data?.mfgName;
                if (name && name.length > 56) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              RenderLabelerName: (cellInfo) => {
                const name = cellInfo?.data?.labelerName;
                if (name && name.length > 56) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        )}
        {state.mfgTypeCd === 'G' && (
          <TableGrid
            ref={gridRef}
            gridHeight={fullScreenView ? '70vh' : 400}
            rowData={manufacturerFilterByGovList}
            columnDefs={manuFactureHead}
            cellClickedListener={(e) => {
              dispatch(setSelectManufacturerData({}));
              dispatch(fetchAllManufacturerDetail(null));
              dispatch(getContactDetails(null));
              dispatch(maintainLabelerListData({}));
              dispatch(setMaintainManufacturerTab({}));
              dispatch(getSingleContractUsingContact(null));
              const Obj = e?.data;
              Obj.createManufacturer = false;
              Obj.callAllProviderAPI = true;
              getManufacturerDetails(Obj, history, dispatch, state);
            }}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            helpMessage="* On Double Click of Results, system should navigate to Detail page"
            data-testid="onEditingStopped"
            fileName="Manufacturer"
            frameworkComponents={{
              RenderMFGName: (cellInfo) => {
                const name = cellInfo?.data?.mfgName;
                if (name && name.length > 56) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              RenderLabelerName: (cellInfo) => {
                const name = cellInfo?.data?.labelerName;
                if (name && name.length > 56) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        )}
      </div>
    </div>
  );
};
export default withRouter(ManufacturerSearch);
